/*  ========================================================================
    # JavaScript - Main
    ========================================================================  */

import TextWithMediaShortcode from './scripts/text-with-media-shortcode';

const scripts = [
  TextWithMediaShortcode
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
